import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountryDropdownModule } from 'app/account/components/country-dropdown/country-dropdown.module';
import { CustomerDropdownModule } from 'app/customer/components/customer-dropdown/customer-dropdown.module';
import { MaterialModule } from 'app/material-barrel/material-barrel.module';
import { GenericGridModule } from 'app/shared/generic-grid/generic-grid.module';
import { LookupDropdownModule } from 'app/shared/lookup-dropdown/lookup-dropdown.module';
import { VendorDropdownModule } from 'app/vendor/components/vendor-dropdown/vendor-dropdown.module';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { AddressModule } from '../address/address.module';
import { CoreModule } from '../core/core.module';
import { CustomerModule } from '../customer/customer.module';
import { DictionaryModule } from '../dictionary/dictionary.module';
import { LocationModule } from '../location/location.module';
import { SharedModule } from '../shared/shared.module';
import { SiteDropdownModule } from '../site/components/site-dropdown/site-dropdown.module';
import { SiteModule } from '../site/site.module';
import { VendorModule } from '../vendor/vendor.module';
import { ContactDropdownModule } from './components/contact-dropdown/contact-dropdown.module';
import { ContactManageDialogComponent } from './components/contact-manage-dialog/contact-manage-dialog.component';
import { ContactSneakPeekComponent } from './components/contact-sneak-peek/contact-sneak-peek.component';
import { ContactsGridComponent } from './components/contacts-grid/contacts-grid.component';
import { ContactRoutingModule } from './contact-routing.module';
import { ContactComponent } from './contact.component';
import { ContactService } from './core/contact.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ContactRoutingModule,
		FlexLayoutModule,
		ReactiveFormsModule,
		ContactDropdownModule,
		DxButtonModule,
		DxDataGridModule,
		MaterialModule,
		SharedModule,
		VendorModule,
		LocationModule,
		SiteModule,
		CoreModule,
		DictionaryModule,
		CustomerModule,
		AddressModule,
		CountryDropdownModule,
		NgxMaskDirective,
		NgxMaskPipe,
		LookupDropdownModule,
		VendorDropdownModule,
		SiteDropdownModule,
		CustomerDropdownModule,
		GenericGridModule
	],
	declarations: [ContactManageDialogComponent, ContactComponent, ContactSneakPeekComponent, ContactsGridComponent],
	providers: [ContactService]
})
export class ContactModule {}
